/* @flow */

import { compose } from 'ramda';
import { connect } from 'react-redux';

import PostBraindateFeedbackTakeOverDumb from './PostBraindateFeedbackTakeOverDumb';
import {
  setPostBraindateFeedback,
  showPostBraindateSuccessNotification,
} from 'src/shared/app/post-braindate/action/postBraindateActions';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getNotificationData } from 'src/shared/app/notification/util/notificationUtil';
import { trackGAEvent } from 'src/shared/core/service/tracking/gaService';
import { getMembership } from 'src/shared/domain/membership/selector/membershipSelectors';
import { getSelf } from 'src/shared/domain/user/selector/userSelectors';

import type { Braindate } from '@e180/domain/lib/braindate/type';
import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  notification: Notification,
};

const mapStateToProps = (state: State, { notification }: Props): Object => {
  // $FlowIssue - braindate is always passed in data
  const braindate: Braindate = getNotificationData(notification);

  return {
    braindate,
    membership: getMembership(state),
    selfUser: getSelf(state),
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (
  stateProps: Object,
  { dispatch }: Object,
  { notification }: Props,
): Object => {
  const { braindate } = stateProps;

  return {
    ...stateProps,
    handleClick(value: string) {
      dispatch(setPostBraindateFeedback(value, braindate));

      trackGAEvent('Self check-in', 'Give feedback', value);

      dispatch(dismissNotification(notification));
      dispatch(showPostBraindateSuccessNotification());
    },

    handleDismiss() {
      dispatch(dismissNotification(notification));

      trackGAEvent('Self check-in', 'Dismiss feedback');
    },
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(PostBraindateFeedbackTakeOverDumb);
